<template>
  <v-card flat unelevated tile fill-height align="center" justify="center">
    <v-card-text v-if="bodyProps.status !== 'success'">
      {{ message }}
    </v-card-text>
    <v-card-text v-if="bodyProps.status !== 'error'">
      <a href="https://www.cartadono.it">https://www.cartadono.it</a>
    </v-card-text>
    <v-card-text v-if="bodyProps.status !== 'error' && bodyProps.banners">
      <a v-for="banner in bodyProps.banners" :key="banner.id" target="_blank" :href="banner.url || '#'">
        <!-- <v-img fill :src="banner.banner ||
      'https://placehold.co/600x400'"></v-img> -->
      <v-img contain aspect-ratio="1.7" :src="banner.banner ||
      'https://placehold.co/600x400'" max-width="350"></v-img>
      </a>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    bodyProps: {
      type: Object
    }
  },
  data () {
    return {
      statement: '',
      message: '',
      qrcodeSuccess: false,
      qrcodeError: false,
      qrcodeLeadCreated: false,
      campaign: null
    }
  },
  created () {
    if (JSON.parse(sessionStorage.getItem('campaign'))) {
      const campaign = JSON.parse(sessionStorage.getItem('campaign'))
      this.campaign = campaign
    }
  },

  mounted () {
    this.revealMessage(this.$route.params.status)
  },

  methods: {
    revealMessage (status) {
      if (this.bodyProps.status === 'success') {
        this.qrcodeSuccess = true
        this.statement = 'Successo'
        this.message =
          'Abbiamo ricevuto il tuo voto, grazie per il tuo supporto.'
      }
      if (this.bodyProps.status === 'error') {
        this.qrcodeError = true
        this.statement = 'Qualcosa è andato storto'
        this.message = 'Attenzione, questa gift card risulta già utilizzata in caso di errore scrivi a segnalazione@cartadono.it'
      }
      if (this.bodyProps.status === 'leadCreated') {
        this.qrcodeLeadCreated = true
        this.statement = 'Successo'
        this.message =
          'Controlla la tua casella di posta, riceverai una mail per confermare la tua email.'
      }
    }
  }
}
</script>
<style scoped>
.container {
  background-color: #fff;
  padding: 0;
}
</style>
